



import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
import {Component} from 'vue-property-decorator';

Vue.use(VueClipboard as any);
@Component({
  name: 'App'
})
export default class App extends Vue {
}
